/*
  Guide des tailles interactif (section q4-guide-tailles).
  Deux façons d'obtenir un verdict : choisir son type de véhicule, ou saisir la largeur et la hauteur de
  son pare-brise ; les mesures saisies priment. Avec un second modèle plus petit (data-largeur-2), le verdict
  dit lequel choisir : les deux si le petit suffit, sinon le grand seulement. Les erreurs de saisie ne s'affichent qu'à la validation
  du champ (événement change), jamais à chaque frappe. Chargé en « defer » par la section.
*/
(() => {
  const initialiser = (racine) => {
    if (racine.dataset.q4Pret) return;
    racine.dataset.q4Pret = '1';

    const d = racine.dataset;
    const largeurBache = parseFloat(d.largeur) || 225;
    const hauteurBache = parseFloat(d.hauteur) || 110;
    const margeCote = parseFloat(d.margeCote) || 0;
    const margeHaut = parseFloat(d.margeHaut) || 0;
    // getAttribute : « data-largeur-2 » (tiret suivi d'un chiffre) n'a pas d'équivalent dans dataset
    const attribut = (nom) => parseFloat(racine.getAttribute('data-' + nom)) || 0;
    const largeur2 = attribut('largeur-2');
    const hauteur2 = attribut('hauteur-2');
    const margeCote2 = attribut('marge-cote-2');
    const margeHaut2 = attribut('marge-haut-2');
    const sortie = racine.querySelector('[data-q4-guide-resultat]');
    const champLargeur = racine.querySelector('[data-q4-largeur]');
    const champHauteur = racine.querySelector('[data-q4-hauteur]');
    if (!sortie || !champLargeur || !champHauteur) return;

    const remplir = (modele, valeurs) =>
      (modele || '').replace(/\[([A-Z0-9_]+)\]/g, (tout, cle) => (cle in valeurs ? valeurs[cle] : tout));
    const nombre = (valeur) => String(valeur).replace('.', ',');
    const lire = (champ) => parseFloat(champ.value.trim().replace(',', '.'));

    const afficher = (etat, titre, texte, source = 'mesures') => {
      sortie.dataset.etat = etat;
      sortie.dataset.source = source;
      const paragraphe = document.createElement('p');
      const fort = document.createElement('strong');
      fort.textContent = titre || '';
      paragraphe.append(fort, document.createTextNode(' ' + (texte || '')));
      sortie.replaceChildren(paragraphe);
      sortie.classList.remove('est-maj');
      void sortie.offsetWidth; // relance l'animation d'apparition
      sortie.classList.add('est-maj');
    };

    // Verdict du type de véhicule coché, sinon message d'attente
    const afficherVehicule = (radio) =>
      afficher(radio.dataset.etat === 'ok' ? 'ok' : 'mesurer', radio.dataset.titre, radio.dataset.message, 'vehicule');
    const revenirSansMesures = () => {
      champLargeur.removeAttribute('aria-invalid');
      champHauteur.removeAttribute('aria-invalid');
      const radio = racine.querySelector('input[type="radio"]:checked');
      if (radio) afficherVehicule(radio);
      else afficher('attente', d.titreAttente, d.texteAttente, 'attente');
    };

    // Renvoie true si les deux mesures sont saisies (un verdict ou une erreur a alors été affiché).
    const verifier = (signalerErreur) => {
      if (!champLargeur.value.trim() || !champHauteur.value.trim()) {
        // Une mesure effacée après un verdict : pas de verdict périmé à l'écran
        if (sortie.dataset.source === 'mesures') revenirSansMesures();
        return false;
      }
      const largeur = lire(champLargeur);
      const hauteur = lire(champHauteur);
      // Champ hors limites signalé sur le champ lui-même (aria-invalid), en plus du message
      const largeurOk = largeur >= 50 && largeur <= 300;
      const hauteurOk = hauteur >= 30 && hauteur <= 250;
      // « aria-invalid » vide vaudrait « false » pour les lecteurs d'écran : valeur explicite ou rien
      const marquer = (champ, ok) => (ok ? champ.removeAttribute('aria-invalid') : champ.setAttribute('aria-invalid', 'true'));
      if (signalerErreur || largeurOk) marquer(champLargeur, largeurOk);
      if (signalerErreur || hauteurOk) marquer(champHauteur, hauteurOk);
      if (!largeurOk || !hauteurOk) {
        if (signalerErreur) afficher('invalide', d.titreInvalide, d.texteInvalide);
        return true;
      }
      const valeurs = {
        MARGE_L: Math.max(0, Math.floor((largeurBache - largeur) / 2)),
        MARGE_H: Math.max(0, Math.floor(hauteurBache - hauteur)),
        LARGEUR: nombre(largeur),
        HAUTEUR: nombre(hauteur),
        MARGE_L2: Math.max(0, Math.floor((largeur2 - largeur) / 2)),
        MARGE_H2: Math.max(0, Math.floor(hauteur2 - hauteur)),
      };
      const petitSuffit = largeur2 > 0 && largeur <= largeur2 - 2 * margeCote2 && hauteur <= hauteur2 - margeHaut2;
      if (petitSuffit && d.texteDeux) {
        afficher('ok', d.titreDeux, remplir(d.texteDeux, valeurs));
      } else if (largeur <= largeurBache - 2 * margeCote && hauteur <= hauteurBache - margeHaut) {
        afficher('ok', d.titreOk, remplir(d.texteOk, valeurs));
      } else if (largeur <= largeurBache && hauteur <= hauteurBache) {
        afficher('juste', d.titreJuste, remplir(d.texteJuste, valeurs));
      } else {
        afficher('trop', d.titreTrop, remplir(d.texteTrop, valeurs));
      }
      return true;
    };

    racine.addEventListener('change', (evenement) => {
      const cible = evenement.target;
      if (cible.matches('input[type="radio"]')) {
        if (verifier(true)) return; // des mesures saisies priment sur le type de véhicule
        afficherVehicule(cible);
      } else if (cible === champLargeur || cible === champHauteur) {
        verifier(true);
      }
    });
    racine.addEventListener('input', (evenement) => {
      if (evenement.target === champLargeur || evenement.target === champHauteur) verifier(false);
    });
  };

  const toutInitialiser = (contexte) => contexte.querySelectorAll('[data-q4-guide]').forEach(initialiser);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => toutInitialiser(document));
  } else {
    toutInitialiser(document);
  }
  document.addEventListener('shopify:section:load', (evenement) => toutInitialiser(evenement.target));
})();
